import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2951acf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-xiaoxi",
  style: {"font-size":"14px","margin-right":"4px","display":"inline-block","vertical-align":"bottom"}
}, null, -1))
const _hoisted_2 = { style: {"font-size":"12px"} }

import { computed } from 'vue'
import { bury } from '@/util/useBury'
import { useRouter } from 'vue-router'
import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { useStore } from 'vuex'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()

const num: any = computed(() => store.state.message.num)

const upBurying = () => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: 'message'
    }
  })
  if (!store.getters.isLogin) {
    taTrack({
      event: TaEvent.PUPUP_WINDOW,
      value: {
        source: 'message',
        position: 'login'
      }
    })
  }
  router.push(useRtfix('Information'))
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    class: "rel",
    type: "default",
    onClick: upBurying
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('消息')), 1),
      _withDirectives(_createElementVNode("span", { class: "abs cart-num" }, _toDisplayString(_unref(num) > 99 ? '99+' : _unref(num)), 513), [
        [_vShow, _unref(num) && _unref(num) !== 0]
      ])
    ]),
    _: 1
  }))
}
}

})